import { useDispatch } from "react-redux";
import { makeCall } from "../../../state/actions/phone";

const VOIPCallButton = (props) =>  {
	const dispatch = useDispatch()
	const handleCall = async () => {
		
		let { from, to, toName,closeCallHistory } = props;
		// closeCallHistory()
		console.log("making call ======voip", from, to, toName);
		if (props.video === true) {
			dispatch(makeCall("voip", from, to, toName, to, null, "on-call", true))
		} else {
			dispatch(makeCall("voip", from, to, toName, null, null, "on-call"))
		}
	};

		const { className = "", style = {} } = props;
		return (
			<a onClick={handleCall} className={className} style={style}>
				{props?.children}
			</a>
		);
	
}

export default VOIPCallButton;
